/**
 * Determines whether a descendent (including itself) of given {@param leftNavLink}
 * has the same identifier as {@code props.selectedIdentifier}
 */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
var hideNonExpandedChildLinks = function(leftNavLink, selectedIdentifier) {
    var isNode = leftNavLink.identifier === selectedIdentifier;
    if (isNode) {
        leftNavLink.childNavLinks = leftNavLink.childNavLinks.slice(0).map(function(childNavLink) {
            return _object_spread_props(_object_spread({}, childNavLink), {
                childNavLinks: []
            });
        });
        return true;
    }
    var isChildNodeExpanded = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = leftNavLink.childNavLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var childNavLink = _step.value;
            var shouldExpandChildNode = hideNonExpandedChildLinks(childNavLink, selectedIdentifier);
            if (!shouldExpandChildNode) {
                childNavLink.childNavLinks = [];
            }
            isChildNodeExpanded = isChildNodeExpanded || shouldExpandChildNode;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return isChildNodeExpanded;
};
export var filterLinksToVisibleNodes = function(leftNavLinks, selectedIdentifier) {
    // Shallow copy
    var rootNode = {
        name: "",
        childNavLinks: leftNavLinks.slice(0),
        to: ""
    };
    hideNonExpandedChildLinks(rootNode, selectedIdentifier);
    return rootNode.childNavLinks;
};
